var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTimeCountDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u5012\u8BA1\u65F6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 22,
    height: 22,
    rx: 9
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-29.5%",
    y: "-25.0%",
    width: "159.1%",
    height: "159.1%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.75641855   0 0 0 0 0.743855087   0 0 0 0 0.902468806  0 0 0 1 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u4F1A\\u6240\\u7BA1\\u7406",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u6253\\u4F4D\\u7BA1\\u7406",
    transform: "translate(-248.000000, -322.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u798F\\u5229\\u6A21\\u5757\\u5907\\u4EFD-3",
    transform: "translate(232.000000, 182.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-8",
    transform: "translate(0.000000, 48.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5012\\u8BA1\\u65F6",
    transform: "translate(17.000000, 92.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fillOpacity: 0,
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-5\\u5907\\u4EFD-2",
    transform: "translate(3.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u77E9\\u5F62\\u5907\\u4EFD-2"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#3F379C",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.18734456,6.2315564 L6.17487799,7.35988731 C5.92849978,7.67678023 5.94422166,8.15212372 6.21086518,8.44794277 C6.47750871,8.74376182 6.90410747,8.75913669 7.18734456,8.48313566 L8.19981113,7.35988731 C8.33517579,7.21091691 8.41136668,7.00773496 8.41136668,6.79572186 C8.41136668,6.58370875 8.33517579,6.3805268 8.19981113,6.2315564 C7.91917614,5.92281453 7.46797955,5.92281453 7.18734456,6.2315564 L7.18734456,6.2315564 Z M14.7671619,6.2315564 C14.4862467,5.92887215 14.0394539,5.93306801 13.7631558,6.24098509 C13.4868576,6.54890217 13.4830926,7.04682486 13.7546953,7.35988731 L14.7671619,8.48313566 C14.9475593,8.69053813 15.214007,8.77399166 15.4649429,8.70168624 C15.7154664,8.63022167 15.9114673,8.41289264 15.9768595,8.13406473 C16.0422516,7.85523682 15.9667365,7.55882236 15.7796284,7.35988731 L14.7671619,6.2315564 Z",
    id: "\\u5F62\\u72B6",
    fillOpacity: 0.4,
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "daojishi-3",
    transform: "translate(6.909091, 7.818182)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.09090909,0 C1.83156239,0 0,1.83156239 0,4.09090909 C0,6.35025579 1.83156239,8.18181818 4.09090909,8.18181818 C6.35025579,8.18181818 8.18181818,6.35025579 8.18181818,4.09090909 C8.18181818,1.83156239 6.35025579,0 4.09090909,0 Z M5.82618336,5.79581606 C5.56030291,6.05368028 5.13766296,6.05368028 4.87178251,5.79581606 L3.87833799,4.84141521 C3.83175194,4.79384458 3.76841597,4.75137499 3.73732396,4.6924979 C3.51393838,4.5740862 3.39775954,4.3307216 3.39679932,4.07789454 L3.39679932,2.03894727 C3.39677092,1.79559644 3.52658069,1.57071881 3.73732396,1.44903517 C3.94806722,1.32735153 4.20772185,1.32735153 4.41846511,1.44903517 C4.62920838,1.57071881 4.75901815,1.79559644 4.75898968,2.03894727 L4.75898968,3.80892702 C4.7870059,3.82972689 4.81313595,3.8529536 4.83707703,3.878338 L5.82618336,4.84141521 C6.07693137,5.11427781 6.06540187,5.53702607 5.80015425,5.79581606 L5.82618336,5.79581606 Z",
    id: "\\u5F62\\u72B6\\u7ED3\\u5408"
  }))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeCountDown);
export default __webpack_public_path__ + "static/media/time_count_down.3b434e066b5df45137505fa09d5d4baa.svg";
export { ForwardRef as ReactComponent };